import makeStyles from "@material-ui/core/styles/makeStyles";

export const useAcademicsPageStyles = makeStyles(() => ({
  root: {
    position: "relative",
  },
  container: {
    padding: "unset",
    marginTop: 24,
  },
  listContainer: {
    border: "1px solid #e8eaf0",
    borderRadius: 15,
    overflow: "hidden",
    "& .MuiPaper-elevation1": {
      padding: "unset",
    },
    minHeight: 480,
    backgroundColor: "#ffffff",
  },
  buttonContainer: {
    padding: "unset",
    textAlign: "right",
  },
  stickyContainer: {
    position: "sticky",
    top: 120,
  },
  button: {
    maxWidth: 280,
    fontSize: 16,

    "&+&": {
      marginLeft: 16,
    },
  },
  info: {
    height: 400,
  },
}));
